/* eslint-disable import/no-extraneous-dependencies */
// eslint-disable-next-line object-curly-newline
/* eslint-disable max-len */
import {
    ApolloClient, HttpLink, InMemoryCache, from, ApolloLink,
} from '@apollo/client';
import { RetryLink } from 'apollo-link-retry';
import fetch from 'isomorphic-unfetch';
import { IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import { onError } from 'apollo-link-error';
import cookies from 'js-cookie';

import { removeIsLoginFlagging } from '@helper_auth';
import { getAppEnv } from '@helpers/env';
import getConfig from 'next/config';

const fragmentMatcher = new IntrospectionFragmentMatcher({
    introspectionQueryResultData: {
        __schema: {
            types: [],
        },
    },
});

const appEnv = getAppEnv();
const { publicRuntimeConfig } = getConfig();

const uri = publicRuntimeConfig.GRAPHQL_URL;

const uriMultipleName = publicRuntimeConfig.GRAPHQL_MULTIPLE_NAME;
const uriMultiple = publicRuntimeConfig.GRAPHQL_MULTIPLE_URL;

const uriInternal = `${publicRuntimeConfig.BASE_URL}/graphql`;
// handle if token expired
const logoutLink = onError((err) => {
    const { graphQLErrors, networkError } = err;
    if (networkError && typeof window !== 'undefined' && graphQLErrors && graphQLErrors.length > 0 && graphQLErrors[0].status > 500) {
        window.location.href = '/maintenance';
    } else if (graphQLErrors && graphQLErrors[0] && graphQLErrors[0].extensions && graphQLErrors[0].extensions.category === 'graphql-seller-authorization') {
        window.location.href = '/seller/unauthorized';
    } else if (graphQLErrors && graphQLErrors[0] && graphQLErrors[0].status === 401 && typeof window !== 'undefined') {
        removeIsLoginFlagging();
        window.location.href = '/login';
    } else if (networkError && networkError.statusCode === 413 && typeof window !== 'undefined') {
        networkError.message = 'Your file is too large. Please choose smaller file size.';
    }
});

const link = new RetryLink({
    attempts: (count, operation, error) => !!error && !['upload', 'report'].some((v) => operation.operationName?.toLowerCase().includes(v)),
}).split(
    (operation) => operation.getContext().request === 'internal',
    new HttpLink({
        uri: uriInternal, // Server URL (must be absolute)
        credentials: 'same-origin', // Additional fetch() options like `credentials` or `headers`
        fetch,
    }),
    new RetryLink().split(
        (operation) => operation.getContext().request === `${uriMultipleName}`,
        new HttpLink({
            uri: uriMultiple, // Server URL (must be absolute)
            credentials: 'same-origin', // Additional fetch() options like `credentials` or `headers`
            fetch,
            useGETForQueries: true,
        }),
        new HttpLink({
            uri, // Server URL (must be absolute)
            credentials: 'same-origin', // Additional fetch() options like `credentials` or `headers`
            fetch,
            useGETForQueries: true,
        }),
    ),
);

// const link = new RetryLink().split(
//     (operation) => operation.getContext().request === 'internal',
//     new HttpLink({
//         uri: uriInternal, // Server URL (must be absolute)
//         credentials: 'same-origin', // Additional fetch() options like `credentials` or `headers`
//         fetch,
//     }),
//     new RetryLink().split(
//         (operation) => operation.getContext().request === chatContextName,
//         new HttpLink({
//             uri: chatUri,
//             credentials: 'same-origin',
//             fetch,
//             useGETForQueries: true,
//         }),
//         new HttpLink({
//             uri, // Server URL (must be absolute)
//             credentials: 'same-origin', // Additional fetch() options like `credentials` or `headers`
//             fetch,
//             useGETForQueries: true,
//         }),
//     ),
// );

export default function createApolloClient(initialState, ctx) {
    const middlewareHeader = new ApolloLink((operation, forward) => {
        const additionalHeader = {};
        operation.setContext((req) => {
            const { headers = {} } = req;
            const language = req?.language ?? false;
            if (!language) {
                const store_code = cookies.get('language_store_code');
                if (store_code) {
                    // eslint-disable-next-line eqeqeq
                    if (store_code != 'undefined') {
                        const store_code_parse = JSON.parse(store_code);
                        additionalHeader.Store = store_code_parse;
                    }
                }
            }

            return {
                headers: {
                    ...headers,
                    ...additionalHeader,
                },
            };
        });

        return forward(operation);
    });
    // The `ctx` (NextPageContext) will only be present on the server.
    // use it to extract auth headers (ctx.req) or similar.
    return new ApolloClient({
        ssrMode: Boolean(ctx),
        link: from([
            middlewareHeader,
            logoutLink,
            link,
        ]),
        cache: new InMemoryCache({ fragmentMatcher }).restore(initialState),
        // eslint-disable-next-line no-underscore-dangle
        connectToDevTools: typeof window !== 'undefined' && window.__APOLLO_CLIENT__ && (appEnv === 'local'),
        resolvers: {},
    });
}
